export default __webpack_public_path__ + "static/702e1ff6-3f5e-48a1-b2e0-03af8047d7fc-fd79f7d5b48951a3a149f319d1ce5a4e.woff2";